import { SEARCH_SLOTS } from "../actions";

export const initialState = {
	center: {
		lat: 47.3774337,
		lng: 8.4666756,
	},
	results: [],
};

export type MapState = typeof initialState;

export default function(state = initialState, action) {
	switch (action.type) {
		case SEARCH_SLOTS: {
			const results = action.results;
			return { ...state, results };
		}

		default:
			return state;
	}
}
